import { call, chat } from "../assets";

export const navLinks = [
  {
    label: "Platform",
    links: [
      {
        label: "[AI] Platform",
        link: "/ai-platform",
      },
      {
        label: "Data Assistant",
        link: "/data-assistant",
      },
      {
        label: "PLLM",
        link: "/pllm",
      },
    ],
  },
  {
    label: "Solutions",
    links: [
      {
        label: "Retail & E-commerce",
        link: "/retail",
      },
      {
        label: "Fintech & Finance",
        link: "/fintech",
      },
      {
        label: "Marketing & Advertising",
        link: "/marketing",
      },
    ],
  },
  {
    label: "Technology",
    links: [],
  },
  {
    label: "Resources",
    links: [
      {
        label: "Digital Analytics Support",
        link: "/digital-analytics-support",
      },
      {
        label: "Digital Analytics Training",
        link: "/digital-analytics-training",
      },
      // {
      //   label: "Guides",
      //   link: "/guides",
      // },
      {
        label: "Blog",
        link: "/blog",
      },
      // {
      //   label: "Case Study",
      //   link: "/case-study",
      // },
      // {
      //   label: "Events",
      //   link: "/events",
      // },
    ],
  },
  {
    label: "About Us",
    links: [],
  },
  // {
  //   label: "Events",
  //   links: [
  //     {
  //       label: "[AI] Data Stack Connect",
  //       link: "/event/ai-data-stack-connect-2025",
  //     },
  //   ],
  // },
];

export const footerLinks = [
  {
    label: "PRODUCT",
    links: [
      {
        label: "[AI] Platform",
        link: "/ai-platform",
      },
      {
        label: "Data Assistant",
        link: "/data-assistant",
      },
      {
        label: "PLLM",
        link: "/pllm",
      },
      {
        label: "Request a Demo",
        link: "/demo",
      },
    ],
  },
  {
    label: "COMPANY",
    links: [
      // {
      //   label: "About us",
      //   link: "/company",
      // },
      // {
      //   label: "Contact Us",
      //   link: "/company#contact-us",
      // },
      // {
      //   label: "Careers",
      //   link: "/company#careers",
      // },
      {
        label: "Faqs",
        link: "/#faqs",
      },
    ],
  },
  {
    label: "LEGAL",
    links: [
      {
        label: "Legal information",
        link: "/privacy",
      },
      {
        label: "Privacy",
        link: "/privacy",
      },
      {
        label: "Cookies",
        link: "/",
      },
      {
        label: "ISMS and BCMS policy",
        link: "/isms-and-bcms-policy",
      },
    ],
  },
  {
    label: "CONTACT",
    links: [
      {
        label: "info@analyticsintelligence.com",
        link: "mailto:info@analytics intelligence.com",
      },
      {
        label: "sales@analyticsintelligence.com",
        link: "mailto:sales@analytics intelligence.com",
      },
      {
        label: "support@analyticsintelligence.com",
        link: "mailto:support@analyticsintelligence.com",
      },
      {
        label: "careers@analyticsintelligence.com",
        link: "mailto:careers@analyticsintelligence.com",
      },
    ],
  },
];

export const newFooterLinks = [
  {
    label: "Platform",
    links: [
      {
        label: "[AI] Platform",
        link: "/ai-platform",
      },
      {
        label: "Pulse",
        link: "/pulse",
      },
      {
        label: "CORE",
        link: "/core",
      },
      {
        label: "Data Assistant",
        link: "/data-assistant",
      },
      {
        label: "TradeTutor",
        link: "/tradetutor",
      },
    ],
  },
  {
    label: "Quick links",
    links: [
      {
        label: "Solutions",
        link: "/solutions",
      },
      {
        label: "Technology",
        link: "/technology",
      },
      // {
      //   label: "Marketing & Advertising",
      //   link: "/marketing",
      // },
    ],
  },
  {
    label: "Resources",
    links: [
      {
        label: "Read",
        link: "/blog",
      },
      {
        label: "Events & Webinars",
        link: "/event/ai-data-stack-connect-2025",
      },
    ],
  },
  {
    label: "Company",
    links: [
      {
        label: "About Us",
        link: "/about-us",
      },
      {
        label: "Careers",
        link: "/careers",
      },
      {
        label: "FAQs",
        link: "/faqs",
      },
      {
        label: "Contact",
        link: "/contact",
      },
    ],
  },
  {
    label: "Legal",
    links: [
      {
        label: "Legal information",
        link: "/legal-info",
      },
      // {
      //   label: "Privacy",
      //   link: "/",
      // },
      // {
      //   label: "Cookies",
      //   link: "/",
      // },
      {
        label: "ISMS and BCMS policy",
        link: "/isms-bcms",
      },
    ],
  },

  {
    label: "Contact",
    links: [
      {
        label: "info@analyticsintelligence.com",
        link: "mailto:info@analytics intelligence.com",
      },
      {
        label: "sales@analyticsintelligence.com",
        link: "mailto:sales@analytics intelligence.com",
      },
      {
        label: "support@analyticsintelligence.com",
        link: "mailto:support@analyticsintelligence.com",
      },
      {
        label: "careers@analyticsintelligence.com",
        link: "mailto:careers@analyticsintelligence.com",
      },
    ],
  },
];

export const questions = [
  "What is a RAG platform?",
  "Capabilities of Data Assitant and AI platorm?",
  "What solutions do you offer?",
];

export const aIPlatformQuestions = [
  "How does [AI] integrate data?",
  "What skills enhance AI assistant?",
  "How does KPI monitoring work?",
];

export const dataAssistantQuestions = [
  "What does Data Assistant do?",
  "How does Analytics Engine work?",
  "What is Data Language Model?",
];

export const pllmQuestions = [
  "How does PLLM secure data?",
  "How does DataSyntax improve privacy?",
  "What does DataSyntax represent?",
];

export const retailQuestions = [
  "How does [AI] boost retail marketing?",
  "What insights come from customer data?",
  "How are customers segmented and targeted?",
];

export const fintechQuestions = [
  "How does AI improve financial services?",
  "What tasks can be automated in fintech?",
  "How does the platform enhance decision-making?",
];

export const marketingQuestions = [
  "How does AI enhance marketing strategies?",
  "What alerts can be set for campaign performance?",
  "How are insights shared within the team?",
];

export const digitalAnalyticsQuestions = [
  "How does [AI] optimize digital performance?",
  "What is included in insight reporting?",
  "How do we ensure data accuracy?",
];

export const digitalAnalyticsTrainingQuestions = [
  "What does the digital analytics training cover?",
  "How can I master Adobe Analytics?",
  "What skills are taught in prompt engineering?",
];

export const aboutUsQuestions = [
  "What is the mission of [AI] Analytics Intelligence?",
  "How did [AI] Analytics Intelligence begin?",
  "What core values guide [AI] Analytics Intelligence?",
];

export const privacyPolicyQuestions = [
  "How is personal information collected and used?",
  "What security measures protect personal information?",
  "How does [AI] Analytics comply with privacy regulations?",
];

export const actions = [
  {
    action: "chat",
    desc: "Instant message with our help assistant [AI]Chat",
    icon: chat,
  },
  {
    action: "call",
    desc: "Schedule a Call with a customer care Representative",
    icon: call,
  },
];

export const countries = [
  "Country",
  "Afghanistan",
  "Åland Islands",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Congo",
  "Congo, The Democratic Republic of The",
  "Cook Islands",
  "Costa Rica",
  "Côte d'Ivoire",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands (Malvinas)",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard Island and McDonald Islands",
  "Holy See (Vatican City State)",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran, Islamic Republic of",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea, Democratic People's Republic of",
  "Korea, Republic of",
  "Kuwait",
  "Kyrgyzstan",
  "Lao People's Democratic Republic",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao",
  "Macedonia, The Former Yugoslav Republic of",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia, Federated States of",
  "Moldova, Republic of",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "Netherlands Antilles",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestinian Territory, Occupied",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Réunion",
  "Romania",
  "Russian Federation",
  "Rwanda",
  "Saint Helena",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Pierre and Miquelon",
  "Saint Vincent and The Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia and The South Sandwich Islands",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Svalbard and Jan Mayen",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syrian Arab Republic",
  "Taiwan, Province of China",
  "Tajikistan",
  "Tanzania, United Republic of",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Viet Nam",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

export const languages = [
  {
    label: "en",
    value: "english",
  },
  {
    label: "fr",
    value: "french",
  },
  {
    label: "ar",
    value: "arabic",
  },
  {
    label: "es",
    value: "spanish",
  },
];

export const timezones = ["Time zone", "UTC", "GMT", "PST", "WAT"];

// English Translations (default)
export const english = {
  questions: [
    "What does secure data infrastructure for enterprise AI mean?",
    "How do private fine-tuned models protect enterprise data?",
    "How does RAG and MCP Server improve AI reasoning?",
  ],
  aiPlatformQuestions: [
    "What is the [AI] Platform ?",
    "How does the MCP Server enable contextual data enrichment?",
    "Who is the [AI] Platform designed for?",
  ],
  pulseQuestions: [
    "What is Pulse and what type of data does it track?",
    "How does Pulse improve LLM reasoning with behavioural data?",
    "How is Pulse different from traditional analytics tools?",
  ],
  dataAssistantQuestions: [
    "What does Data Assistant do?",
    "How does Data Assistant deliver explainable insights?",
    "What role does the Analytics Engine play in Data Assistant?",
  ],
  pllmQuestions: [
    "What is a Private Language Model (PLM)?",
    "How does PLM ensure enterprise data privacy?",
    "Why are small fine-tuned models better for analytics workloads?",
  ],
  enterpriseSolutionsQuestions: [
    "What problems does the Enterprise AI solution solve?",
    "How do secure data pipelines support agentic analytics?",
    "Which teams benefit most from the enterprise solution?",
  ],
  capitalMarketsSolutionsQuestions: [
    "How does the platform support capital markets analytics?",
    "What types of market data can be used with LLMs and agents?",
    "How does contextual enrichment improve financial reasoning?",
  ],
  financialInstitutionsSolutionsQuestions: [
    "How does AI improve decision-making in financial institutions?",
    "How is behavioural and transactional data used securely?",
    "What compliance and governance features are supported?",
  ],
  technologyQuestions: [
    "How is enterprise data secured?",
    "How does AI reason on data?",
    "How does the DLM understand intent?",
  ],
  aboutUsQuestions: [
    "What is the vision of [AI] Analytics Intelligence?",
    "Why was the company founded?",
    "What principles guide the platform’s development?",
  ],
  faqPreviewQuestions: [
    "What is the [AI] Platform?",
    "How is enterprise data kept secure?",
    "What solutions does the platform support?",
  ],
  legalInfoPreviewQuestions: [
    "What personal data do you collect?",
    "How is my data used and protected?",
    "Who can my data be shared with?",
  ],
  securityAndContinuityPreviewQuestions: [
    "How is information kept secure?",
    "How do you handle disruptions or incidents?",
    "What standards guide security and continuity?",
  ],
  actions: [
    {
      action: "chat",
      desc: "Instant message with our help assistant [AI]Chat",
      icon: chat,
    },
    {
      action: "call",
      desc: "Schedule a Call with a customer care Representative",
      icon: call,
    },
  ],
  infoTexts: {
    moreInfo:
      "For more info on our product offerings, engage with [AI] Chat, or speak to a customer care representative.",
    scheduleCall:
      "For specific requests, kindly fill out this form to schedule a call with a customer care representative.",
    customerCareRep: "[AI] Customer Care Representative",
    scheduleMessage: "Please schedule a call with our customer representative.",
    feedbackThankYou: "Thank you for your feedback.",
    callRequestSuccess:
      "Call Request Successful, check your email for the call details.",
  },
  countries: [
    "Country",
    "Afghanistan",
    "Åland Islands",
    "Albania",
    "Algeria",
    /*...*/ "Zimbabwe",
  ],
};

// Spanish Translations
export const spanish = {
  questions: [
    "¿Qué significa una infraestructura de datos segura para la IA empresarial?",
    "¿Cómo protegen los modelos privados ajustados con precisión los datos de la empresa?",
    "¿Cómo mejoran RAG y el servidor MCP el razonamiento de la IA?",
  ],
  aiPlatformQuestions: [
    "¿Qué es la plataforma [AI]?",
    "¿Cómo permite el servidor MCP el enriquecimiento de datos contextuales?",
    "¿Para quién está diseñada la plataforma [AI]?",
  ],
  pulseQuestions: [
    "¿Qué es Pulse y qué tipo de datos rastrea?",
    "¿Cómo mejora Pulse el razonamiento de los LLM mediante datos de comportamiento?",
    "¿En qué se diferencia Pulse de las herramientas analíticas tradicionales?",
  ],
  dataAssistantQuestions: [
    "¿Qué hace Data Assistant?",
    "¿Cómo ofrece Data Assistant conocimientos explicables?",
    "¿Qué papel desempeña el motor analítico en Data Assistant?",
  ],
  pllmQuestions: [
    "¿Qué es un Modelo de Lenguaje Privado (PLM)?",
    "¿Cómo garantiza PLM la privacidad de los datos empresariales?",
    "¿Por qué los modelos pequeños ajustados con precisión son mejores para cargas de trabajo analíticas?",
  ],
  enterpriseSolutionsQuestions: [
    "¿Qué problemas resuelve la solución de IA empresarial?",
    "¿Cómo apoyan los pipelines de datos seguros la analítica basada en agentes?",
    "¿Qué equipos se benefician más de la solución empresarial?",
  ],
  capitalMarketsSolutionsQuestions: [
    "¿Cómo respalda la plataforma la analítica de los mercados de capitales?",
    "¿Qué tipos de datos de mercado pueden usarse con LLM y agentes?",
    "¿Cómo mejora el enriquecimiento contextual el razonamiento financiero?",
  ],
  financialInstitutionsSolutionsQuestions: [
    "¿Cómo mejora la IA la toma de decisiones en las instituciones financieras?",
    "¿Cómo se utilizan de forma segura los datos de comportamiento y transaccionales?",
    "¿Qué funciones de cumplimiento y gobernanza se admiten?",
  ],
  technologyQuestions: [
    "¿Cómo se protegen los datos empresariales?",
    "¿Cómo razona la IA sobre los datos?",
    "¿Cómo entiende la intención el DLM?",
  ],
  aboutUsQuestions: [
    "¿Cuál es la visión de [AI] Analytics Intelligence?",
    "¿Por qué se fundó la empresa?",
    "¿Qué principios guían el desarrollo de la plataforma?",
  ],
  faqPreviewQuestions: [
    "¿Qué es la plataforma [AI]?",
    "¿Cómo se mantienen seguros los datos empresariales?",
    "¿Qué soluciones admite la plataforma?",
  ],
  legalInfoPreviewQuestions: [
    "¿Qué datos personales recopilan?",
    "¿Cómo se utilizan y protegen mis datos?",
    "¿Con quién se pueden compartir mis datos?",
  ],
  securityAndContinuityPreviewQuestions: [
    "¿Cómo se mantiene segura la información?",
    "¿Cómo gestionan las interrupciones o incidentes?",
    "¿Qué normas guían la seguridad y la continuidad?",
  ],

  actions: [
    {
      action: "chat",
      desc: "Mensaje instantáneo con nuestro asistente de ayuda [AI]Chat",
      icon: chat,
    },
    {
      action: "call",
      desc: "Programar una llamada con un representante de atención al cliente",
      icon: call,
    },
  ],
  infoTexts: {
    moreInfo:
      "Para obtener más información sobre nuestras ofertas de productos, interactúe con [AI] Chat o hable con un representante de atención al cliente.",
    scheduleCall:
      "Para solicitudes específicas, complete este formulario para programar una llamada con un representante de atención al cliente.",
    customerCareRep: "[AI] Representante de atención al cliente",
    scheduleMessage:
      "Por favor, programe una llamada con nuestro representante de atención al cliente.",
    feedbackThankYou: "Gracias por sus comentarios.",
    callRequestSuccess:
      "Solicitud de llamada exitosa, revise su correo electrónico para los detalles de la llamada.",
  },
  countries: [
    "País",
    "Afganistán",
    "Islas Åland",
    "Albania",
    "Argelia",
    /*...*/ "Zimbabue",
  ],
};

// French Translations
export const french = {
  questions: [
    "Que signifie une infrastructure de données sécurisée pour l’IA d’entreprise ?",
    "Comment les modèles privés finement entraînés protègent-ils les données de l’entreprise ?",
    "Comment le RAG et le serveur MCP améliorent-ils le raisonnement de l’IA ?",
  ],
  aiPlatformQuestions: [
    "Qu’est-ce que la plateforme [AI] ?",
    "Comment le serveur MCP permet-il l’enrichissement des données contextuelles ?",
    "À qui s’adresse la plateforme [AI] ?",
  ],
  pulseQuestions: [
    "Qu’est-ce que Pulse et quels types de données suit-il ?",
    "Comment Pulse améliore-t-il le raisonnement des LLM grâce aux données comportementales ?",
    "En quoi Pulse est-il différent des outils d’analytique traditionnels ?",
  ],
  dataAssistantQuestions: [
    "Que fait Data Assistant ?",
    "Comment Data Assistant fournit-il des insights explicables ?",
    "Quel rôle joue le moteur d’analytique dans Data Assistant ?",
  ],
  pllmQuestions: [
    "Qu’est-ce qu’un modèle de langage privé (PLM) ?",
    "Comment le PLM garantit-il la confidentialité des données d’entreprise ?",
    "Pourquoi les petits modèles finement entraînés sont-ils mieux adaptés aux charges analytiques ?",
  ],
  enterpriseSolutionsQuestions: [
    "Quels problèmes la solution IA pour entreprises résout-elle ?",
    "Comment les pipelines de données sécurisés soutiennent-ils l’analytique agentique ?",
    "Quelles équipes bénéficient le plus de la solution entreprise ?",
  ],
  capitalMarketsSolutionsQuestions: [
    "Comment la plateforme soutient-elle l’analytique des marchés de capitaux ?",
    "Quels types de données de marché peuvent être utilisés avec les LLM et les agents ?",
    "Comment l’enrichissement contextuel améliore-t-il le raisonnement financier ?",
  ],
  financialInstitutionsSolutionsQuestions: [
    "Comment l’IA améliore-t-elle la prise de décision dans les institutions financières ?",
    "Comment les données comportementales et transactionnelles sont-elles utilisées de manière sécurisée ?",
    "Quelles fonctionnalités de conformité et de gouvernance sont prises en charge ?",
  ],
  technologyQuestions: [
    "Comment les données d’entreprise sont-elles sécurisées ?",
    "Comment l’IA raisonne-t-elle à partir des données ?",
    "Comment le DLM comprend-il l’intention ?",
  ],
  aboutUsQuestions: [
    "Quelle est la vision de [AI] Analytics Intelligence ?",
    "Pourquoi l’entreprise a-t-elle été fondée ?",
    "Quels principes guident le développement de la plateforme ?",
  ],
  faqPreviewQuestions: [
    "Qu’est-ce que la plateforme [AI] ?",
    "Comment les données d’entreprise sont-elles protégées ?",
    "Quelles solutions la plateforme prend-elle en charge ?",
  ],
  legalInfoPreviewQuestions: [
    "Quelles données personnelles collectez-vous ?",
    "Comment mes données sont-elles utilisées et protégées ?",
    "Avec qui mes données peuvent-elles être partagées ?",
  ],
  securityAndContinuityPreviewQuestions: [
    "Comment les informations sont-elles sécurisées ?",
    "Comment gérez-vous les interruptions ou incidents ?",
    "Quelles normes guident la sécurité et la continuité ?",
  ],

  actions: [
    {
      action: "chat",
      desc: "Message instantané avec notre assistant d'aide [AI]Chat",
      icon: chat,
    },
    {
      action: "call",
      desc: "Planifier un appel avec un représentant du service client",
      icon: call,
    },
  ],
  infoTexts: {
    moreInfo:
      "Pour plus d'informations sur nos offres de produits, engagez-vous avec [AI] Chat ou parlez à un représentant du service client.",
    scheduleCall:
      "Pour des demandes spécifiques, veuillez remplir ce formulaire pour planifier un appel avec un représentant du service client.",
    customerCareRep: "[AI] Représentant du service client",
    scheduleMessage:
      "Veuillez planifier un appel avec notre représentant client.",
    feedbackThankYou: "Merci pour vos commentaires.",
    callRequestSuccess:
      "Demande d'appel réussie, consultez votre e-mail pour les détails de l'appel.",
  },
  countries: [
    "Pays",
    "Afghanistan",
    "Îles Åland",
    "Albanie",
    "Algérie",
    /*...*/ "Zimbabwe",
  ],
};

// Arabic Translations
export const arabic = {
  questions: [
    "ماذا يعني وجود بنية تحتية آمنة للبيانات من أجل الذكاء الاصطناعي المؤسسي؟",
    "كيف تحمي النماذج الخاصة المُدرَّبة بدقة بيانات المؤسسة؟",
    "كيف يُحسّن نظام RAG وخادم MCP من قدرة الذكاء الاصطناعي على الاستدلال؟",
  ],
  aiPlatformQuestions: [
    "ما هي منصة [AI]؟",
    "كيف يتيح خادم MCP إثراء البيانات بالسياق؟",
    "لمن تم تصميم منصة [AI]؟",
  ],
  pulseQuestions: [
    "ما هو Pulse وما نوع البيانات التي يقوم بتتبعها؟",
    "كيف يُحسّن Pulse استدلال النماذج اللغوية الكبيرة باستخدام البيانات السلوكية؟",
    "بماذا يختلف Pulse عن أدوات التحليلات التقليدية؟",
  ],
  dataAssistantQuestions: [
    "ما الذي يقوم به Data Assistant؟",
    "كيف يقدّم Data Assistant رؤى قابلة للتفسير؟",
    "ما دور محرك التحليلات في Data Assistant؟",
  ],
  pllmQuestions: [
    "ما هو نموذج اللغة الخاص (PLM)؟",
    "كيف يضمن PLM خصوصية بيانات المؤسسة؟",
    "لماذا تُعد النماذج الصغيرة المُدرَّبة بدقة أفضل لأحمال عمل التحليلات؟",
  ],
  enterpriseSolutionsQuestions: [
    "ما المشكلات التي يحلّها حل الذكاء الاصطناعي للمؤسسات؟",
    "كيف تدعم مسارات البيانات الآمنة التحليلات المعتمدة على الوكلاء؟",
    "ما الفرق التي تستفيد أكثر من الحل المؤسسي؟",
  ],
  capitalMarketsSolutionsQuestions: [
    "كيف تدعم المنصة تحليلات أسواق رأس المال؟",
    "ما أنواع بيانات السوق التي يمكن استخدامها مع النماذج اللغوية الكبيرة والوكلاء؟",
    "كيف يُحسّن إثراء البيانات بالسياق الاستدلال المالي؟",
  ],
  financialInstitutionsSolutionsQuestions: [
    "كيف يُحسّن الذكاء الاصطناعي عملية اتخاذ القرار في المؤسسات المالية؟",
    "كيف يتم استخدام البيانات السلوكية والمعاملات بشكل آمن؟",
    "ما ميزات الامتثال والحوكمة المدعومة؟",
  ],
  technologyQuestions: [
    "كيف يتم تأمين بيانات المؤسسة؟",
    "كيف يقوم الذكاء الاصطناعي بالاستدلال على البيانات؟",
    "كيف يفهم نموذج لغة البيانات (DLM) النية؟",
  ],
  aboutUsQuestions: [
    "ما رؤية شركة [AI] Analytics Intelligence؟",
    "لماذا تم تأسيس الشركة؟",
    "ما المبادئ التي توجه تطوير المنصة؟",
  ],
  faqPreviewQuestions: [
    "ما هي منصة [AI]؟",
    "كيف يتم الحفاظ على أمان بيانات المؤسسة؟",
    "ما الحلول التي تدعمها المنصة؟",
  ],
  legalInfoPreviewQuestions: [
    "ما البيانات الشخصية التي يتم جمعها؟",
    "كيف يتم استخدام بياناتي وحمايتها؟",
    "مع من يمكن مشاركة بياناتي؟",
  ],
  securityAndContinuityPreviewQuestions: [
    "كيف يتم الحفاظ على أمان المعلومات؟",
    "كيف يتم التعامل مع الانقطاعات أو الحوادث؟",
    "ما المعايير التي توجه الأمن واستمرارية الأعمال؟",
  ],
  actions: [
    { action: "chat", desc: "رسالة فورية مع مساعدنا [AI]Chat", icon: chat },
    { action: "call", desc: "جدولة مكالمة مع ممثل رعاية العملاء", icon: call },
  ],
  infoTexts: {
    moreInfo:
      "لمزيد من المعلومات حول عروض منتجاتنا، تواصل مع [AI] Chat، أو تحدث إلى ممثل رعاية العملاء.",
    scheduleCall:
      "للطلبات المحددة، يرجى ملء هذا النموذج لتحديد موعد مكالمة مع ممثل رعاية العملاء.",
    customerCareRep: "[AI] ممثل رعاية العملاء",
    scheduleMessage: "يرجى تحديد موعد مكالمة مع ممثل خدمة العملاء.",
    feedbackThankYou: "شكرًا لك على ملاحظاتك.",
    callRequestSuccess:
      "تم طلب المكالمة بنجاح، يرجى التحقق من بريدك الإلكتروني للحصول على تفاصيل المكالمة.",
  },
  countries: [
    "البلد",
    "أفغانستان",
    "جزر آلاند",
    "ألبانيا",
    "الجزائر",
    /*...*/ "زيمبابوي",
  ],
};

export const l = {
  arabic,
  english,
  french,
  spanish,
};

export const prefilledQuestions = (pathname, langKey) => {
  const lang = l[langKey];

  if (!lang) {
    console.error(`Language ${langKey} not found!`);
    return [];
  }

  switch (pathname) {
    case "/ai-platform":
      return lang?.aiPlatformQuestions;
    case "/pulse":
      return lang?.pulseQuestions;
    case "/data-assistant":
      return lang?.dataAssistantQuestions;
    case "/pllm":
      return lang?.pllmQuestions;
    case "/solutions/enterprises":
      return lang?.enterpriseSolutionsQuestions;
    case "/solutions/capital-markets":
      return lang?.capitalMarketsSolutionsQuestions;
    case "/solutions/financial-markets":
      return lang?.financialInstitutionsSolutionsQuestions;
    case "/technology":
      return lang?.technologyQuestions;
    case "/about-us":
      return lang?.aboutUsQuestions;
    case "/faqs":
      return lang?.faqPreviewQuestions;
    case "/legal-info":
      return lang?.legalInfoPreviewQuestions;
    case "/isms-bcms":
      return lang?.securityAndContinuityPreviewQuestions;
    default:
      return lang?.questions;
  }
};
